import { reportAPI } from '@/api'
import { ApiResult } from '@modals/RequiredEmailConfirmation/components/RequiredEmailConfirmationModal/utils/api'

export interface ILessonIncomeStudent {
  student_id: number
  student_name: string
  status: number
  status_label: string
  amount: number
}

export interface ILessonIncomeDetails {
  report_id: number
  total: number
  students: ILessonIncomeStudent[]
}

export const getLessonIncomeDetails = async (
  lessonId: number,
): Promise<ApiResult<ILessonIncomeDetails>> => {
  try {
    const res = await reportAPI.groupLessonPayment.lessonIncomeDetails(lessonId)
    const data = res?.data?.data
    const isSuccessStatus =
      res?.data?.status === undefined || res?.data?.status === 'success'

    return {
      data,
      success: isSuccessStatus && res?.data?.success !== false,
      error:
        res?.data?.error ||
        res?.data?.message ||
        'Не удалось загрузить доход по занятию',
    }
  } catch (error) {
    console.error('Ошибка getLessonIncomeDetails:', error)
    return {
      data: null,
      success: false,
      error: error instanceof Error ? error.message : String(error),
    }
  }
}
